// A simple function to find the closest ancestor element that matches a selector (Not strictly used, but kept for utility)
function findParent(element, selector) {
  while (element && element.nodeType === 1) {
    if (element.matches(selector)) {
      return element;
    }
    element = element.parentNode;
  }
  return null;
}

/**
 * Initializes the carousel functionality for a single section.
 * @param {HTMLElement} wrapper - The outer carousel container (e.g., #RelatedCarousel-{{ section.id }}).
 */
function initSimpleCarousel(wrapper) {
  const slider = wrapper.querySelector('.grid.slider');
  const buttons = wrapper.querySelectorAll('.slider-button');
  const slides = slider ? Array.from(slider.querySelectorAll('.slider__slide')) : [];

  // Check if initialization is valid or already done
  if (!slider || slides.length === 0 || window.innerWidth > 750 || wrapper.hasAttribute('data-initialized')) {
    return;
  }

  // Mark as initialized
  wrapper.setAttribute('data-initialized', true);

  // Use the width of the first slide as the step size
  const slideWidth = slides[0].offsetWidth; 
  const columnsMobile = slider.classList.contains('grid--1-col-tablet-down') ? 1 : 2;
  const itemsPerStep = columnsMobile;
  
  // Get the current slide index based on scroll position
  function getCurrentIndex() {
      const currentIndex = Math.round(slider.scrollLeft / slideWidth / itemsPerStep) * itemsPerStep;
      return Math.min(currentIndex, slides.length - itemsPerStep);
  }

  // Function to move the slider
  function moveSlider(direction) {
    const currentScroll = slider.scrollLeft;
    
    // Calculate the distance to scroll based on the number of items per step
    const scrollDistance = slideWidth * itemsPerStep;
    let targetScroll;

    if (direction === 1) { // Next
        targetScroll = currentScroll + scrollDistance;
    } else { // Previous
        targetScroll = currentScroll - scrollDistance;
    }
    
    // Clamp the target scroll position to prevent overscrolling
    targetScroll = Math.max(0, Math.min(targetScroll, slider.scrollWidth - slider.clientWidth));

    slider.scroll({
      left: targetScroll,
      behavior: 'smooth'
    });
  }

  // Function to update the disabled state of buttons and the counter
  function updateButtonsAndCounter() {
    const scrollLeft = slider.scrollLeft;
    // Tolerance of 5px for start/end check
    const isBeginning = scrollLeft <= 5; 
    const isEnd = (scrollLeft + slider.clientWidth) >= (slider.scrollWidth - 5);
    const currentIndex = getCurrentIndex();

    // Update buttons
    buttons.forEach(button => {
      const action = button.getAttribute('data-slider-action');
      if (action === 'prev') {
        button.disabled = isBeginning;
      } else if (action === 'next') {
        button.disabled = isEnd;
      }
    });

    // Update counter
    const counterCurrent = wrapper.querySelector('.slider-counter--current');
    if (counterCurrent) {
        counterCurrent.textContent = (currentIndex + 1).toString();
    }
  }

  // Set up listeners for button clicks - FIX implemented here
  buttons.forEach(button => {
    // Remove any previous listeners to prevent multiple execution
    const oldHandler = button.__carouselHandler;
    if (oldHandler) {
        button.removeEventListener('click', oldHandler);
    }

    const newHandler = (event) => {
      event.preventDefault();
      
      // FIX: Guarantee initialization happens first if the click listener fired before load/DOMReady
      if (!wrapper.hasAttribute('data-initialized')) {
          initSimpleCarousel(wrapper);
      }
      
      const action = button.getAttribute('data-slider-action');
      if (action === 'prev') {
        moveSlider(-1);
      } else if (action === 'next') {
        moveSlider(1);
      }
    };
    
    button.addEventListener('click', newHandler);
    button.__carouselHandler = newHandler; // Store the handler for potential cleanup
  });

  // Listen for scroll events on the slider container to update buttons
  slider.addEventListener('scroll', updateButtonsAndCounter);

  // Initial update
  setTimeout(updateButtonsAndCounter, 100); 
  window.addEventListener('resize', updateButtonsAndCounter);
}

/**
 * Main function to find all uninitialized carousels and run initialization.
 */
function initializeAllRelatedCarousels() {
  // Find all carousel wrappers that are not yet initialized
  const uninitializedCarousels = document.querySelectorAll(
    '.slider-wrapper:not([data-initialized])'
  );

  uninitializedCarousels.forEach(wrapper => {
    // Check if the parent product-recommendations component has rendered its content
    const productList = wrapper.querySelector('.grid.slider');
    if (productList && productList.children.length > 0) {
      initSimpleCarousel(wrapper);
    }
  });
}


// Attach the initialization logic to common delayed loading events
document.addEventListener('DOMContentLoaded', initializeAllRelatedCarousels);
window.addEventListener('load', initializeAllRelatedCarousels);

// Final fallback and click synchronization handler
// We keep this click listener as it is the most robust way to detect 
// when the AJAX content has finally landed and needs initialization.
document.addEventListener('click', initializeAllRelatedCarousels);